module.exports = __webpack_public_path__ + "fonts/a6382ae.eot";